<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-全分类-添加
    -->
    <el-dialog
    title="添加全分类"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
    :append-to-body="true"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加全分类</div>

      
      
      <el-form-item label="code">
        <el-input v-model="form.code" placeholder="请输入code" style="width: 200px;"></el-input>

        <div>实际举例：code决定了是否属于同一个分类,可中文</div>
      </el-form-item>

    
    
      <el-form-item label="全分类名称" prop="name"><el-input v-model="form.name" placeholder="请输入全分类名称" class="max-w460"></el-input></el-form-item>

     
      <el-form-item label="分类图片">
        <div>
          <el-button type="primary" @click="openUpload(1)">上传图片</el-button>
          <img :src="form.image" class="mt10" width="120px;" v-if="isImg" :isImg="isImg" />
        </div>
      </el-form-item>

      <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>


      <el-form-item label="内容">
      <div class="edit_container" >
        <Uediter v-model="form.richtext" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
      </div>
    </el-form-item>
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
       <!--上传图片组件-->
       <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</el-dialog>
  
</template>

<script>
import CategoryaApi from '@/api/categorya.js';
import Upload from '@/components/file/Upload';
import Uediter from '@/components/UE.vue';
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Uediter,
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:"",
        images_id:"",
        richtext:"",
        sort:50,
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入全分类名称', trigger: 'blur' }],
      },
      dialogVisible:false,
  
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","categorya_id"],
  methods: {
    /*上传*/
    openUpload(upload_type) {
      this.upload_type = upload_type;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      CategoryaApi.detail({categorya_id: self.categorya_id},true).then(res => {
          self.form = res.data;
          self.form.code =  res.data.code;
          self.form.image = res.data.images.file_path
          self.form.image_id = res.data.images.file_id
          self.ueditor.text = res.data.richtext?res.data.richtext:"";
          if(self.form.image){
            self.isImg = true;
          }
          self.loading = false;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.categorya_id = self.categorya_id;
      if( self.form.image_id == "" || self.form.image_id == undefined){
        self.$message({
                type: 'error',
                  message: '请上传图片'
            });
          return false;
      }
      self.form.richtext = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CategoryaApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/categorya/part/edit.vue